const AdditionalBilling = ({
    isBillingEditMode,
    companyName, setCompanyName,
    gstNumber, setGstNumber,
    gstCompanyName, setGstCompanyName,
    gstAddress, setGstAddress,
    billingInstruction, setBillingInstruction,
    marketSegment, setMarketSegment,
    businessSource, setBusinessSource,
    guaranteeCode, setGuaranteeCode,
    bookingComment, setBookingComment,
    paymentComment, setPaymentComment,
    marketSegments,
    businessSources,
    guaranteeCodes,
    handleBillingEdit,
    handleBillingDone,
    handleBillingCancel,
}) => {
    return (
        <div className="card mb-4">
            <div className="card-header d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center">
                    <span className="material-symbols-outlined me-2 text-primary">receipt_long</span>
                    Additional &amp; Billing Details
                </div>
                {!isBillingEditMode ? (
                    <button type="button" className="btn btn-sm btn-primary" onClick={handleBillingEdit}>Edit</button>
                ) : (
                    <div className="d-flex gap-2">
                        <button type="button" className="btn btn-sm btn-success" onClick={handleBillingDone}>Done</button>
                        <button type="button" className="btn btn-sm btn-secondary" onClick={handleBillingCancel}>Cancel</button>
                    </div>
                )}
            </div>
            <div className="card-body">

                {/* Company Name */}
                <div className="row g-3 mb-4">
                    <div className="col-md-4">
                        <label className="form-label">Company Name</label>
                        {isBillingEditMode ? (
                            <input className="form-control" value={companyName} onChange={(e) => setCompanyName(e.target.value)} />
                        ) : (
                            <div className="form-control-plaintext fw-semibold">{companyName || "-"}</div>
                        )}
                    </div>
                </div>

                {/* GST Section */}
                <div className="gst-section mb-4">
                    <h6 className="small fw-bold mb-3 d-flex align-items-center">
                        <span className="material-symbols-outlined fs-6 me-1">verified</span>
                        Enter GST Details (Optional)
                    </h6>
                    <div className="row g-3">
                        <div className="col-md-4">
                            <label className="form-label">Registration Number</label>
                            {isBillingEditMode ? (
                                <input className="form-control bg-white" placeholder="Enter Registration Number" type="text"
                                    value={gstNumber} onChange={(e) => setGstNumber(e.target.value)} />
                            ) : (
                                <div className="form-control-plaintext fw-semibold">{gstNumber || "-"}</div>
                            )}
                        </div>

                        <div className="col-md-4">
                            <label className="form-label">Registered Company name</label>
                            {isBillingEditMode ? (
                                <input className="form-control bg-white" placeholder="Enter Registered Company Name" type="text"
                                    value={gstCompanyName} onChange={(e) => setGstCompanyName(e.target.value)} />
                            ) : (
                                <div className="form-control-plaintext fw-semibold">{gstCompanyName || "-"}</div>
                            )}
                        </div>

                        <div className="col-md-4">
                            <label className="form-label">Registered Company address</label>
                            {isBillingEditMode ? (
                                <textarea className="form-control bg-white" placeholder="Registered Company Address"
                                    rows={2} style={{ resize: "none" }} value={gstAddress}
                                    onChange={(e) => setGstAddress(e.target.value)} />
                            ) : (
                                <div className="form-control-plaintext fw-semibold">{gstAddress || "-"}</div>
                            )}
                        </div>
                    </div>
                </div>

                {/* Billing Dropdowns */}
                <div className="row g-3 mb-4">
                    <div className="col-md-3">
                        <label className="form-label">Billing Instructions:</label>
                        {isBillingEditMode ? (
                            <select className="form-select form-control" value={billingInstruction}
                                onChange={(e) => setBillingInstruction(e.target.value)}>
                                <option value="">Select Billing Instruction</option>
                                <option value="Pay at hotel">Pay at hotel</option>
                                <option value="Prepaid">Prepaid</option>
                                <option value="Send Invoice">Send Invoice</option>
                            </select>
                        ) : (
                            <div className="form-control-plaintext fw-semibold">{billingInstruction || "-"}</div>
                        )}
                    </div>

                    <div className="col-md-3">
                        <label className="form-label">Market Segment</label>
                        {isBillingEditMode ? (
                            <select className="form-select form-control" value={marketSegment}
                                onChange={(e) => setMarketSegment(e.target.value)}>
                                <option value="">Select</option>
                                {marketSegments?.map((item) => (
                                    <option key={item.ID} value={item.Code}>{item.MarketSeg}</option>
                                ))}
                            </select>
                        ) : (
                            <div className="form-control-plaintext fw-semibold">
                                {marketSegment?.MarketSeg || "-"}
                            </div>
                        )}
                    </div>

                    <div className="col-md-3">
                        <label className="form-label">Business Source</label>
                        {isBillingEditMode ? (
                            <select className="form-select form-control" value={businessSource}
                                onChange={(e) => setBusinessSource(e.target.value)}>
                                <option value="">Select</option>
                                {businessSources?.map((item) => (
                                    <option key={item.ID} value={item.Code}>{item.BusinessSource}</option>
                                ))}
                            </select>
                        ) : (
                            <div className="form-control-plaintext fw-semibold">
                                {businessSource?.BusinessSource || "-"}
                            </div>
                        )}
                    </div>

                    <div className="col-md-3">
                        <label className="form-label">Guarantee Codes</label>
                        {isBillingEditMode ? (
                            <select className="form-select form-control" value={guaranteeCode}
                                onChange={(e) => setGuaranteeCode(e.target.value)}>
                                <option value="">Select</option>
                                {guaranteeCodes?.map((item) => (
                                    <option key={item.ID} value={item.Code}>{item.guaranteeCodes}</option>
                                ))}
                            </select>
                        ) : (
                            <div className="form-control-plaintext fw-semibold">
                                {guaranteeCode?.guaranteeCodes || "-"}
                            </div>
                        )}
                    </div>
                </div>

                {/* Comments */}
                <div className="row g-3">
                    <div className="col-md-6">
                        <label className="form-label">Booking Comment</label>
                        {isBillingEditMode ? (
                            <textarea className="form-control" rows={2} value={bookingComment}
                                onChange={(e) => setBookingComment(e.target.value)} />
                        ) : (
                            <div className="form-control-plaintext fw-semibold">{bookingComment || "-"}</div>
                        )}
                    </div>

                    <div className="col-md-6">
                        <label className="form-label">Payment Comment</label>
                        {isBillingEditMode ? (
                            <textarea className="form-control" rows={2} value={paymentComment}
                                onChange={(e) => setPaymentComment(e.target.value)} />
                        ) : (
                            <div className="form-control-plaintext fw-semibold">{paymentComment || "-"}</div>
                        )}
                    </div>
                </div>

            </div>
        </div>
    );
};

export default AdditionalBilling;